
<template>
   <div>
            <div id="email-app" class="border border-solid d-theme-border-grey-light relative overflow-hidden mx-4">

              <div :class="{'sidebar-spacer': clickNotClose}" class="app-fixed-height">
                  <div class="flex border d-theme-dark-bg items-center">
                      <vs-input 
                      icon-no-border icon="icon-search"
                      size="large" icon-pack="feather" 
                      placeholder="Search" 
                      v-model="search" 
                      @input="getMessages('search')"
                       maxLength="30"
                      class="vs-input-no-border vs-input-no-shdow-focus w-full" />
                  </div>

                  <div class="email__actions flex items-center flex-wrap justify-between p-4 border border-r-0 border-l-0 border-solid d-theme-border-grey-light">
                      <div class="flex items-center">
                          <vs-checkbox v-model="selectAllCheckBox" icon-pack="feather" :icon="selectAllIcon" class="select-all-chexkbox ml-0">Select All</vs-checkbox>
                      </div>
                      <div class="flex">
                          <feather-icon v-if="mailFilter != 'trash'" icon="TrashIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="confirmDelete = true" />
                      </div>
                  </div>

                  <h5 class="text-center my-6" v-if="hasData">No Data Available</h5>
                  <VuePerfectScrollbar class="email-content-scroll-area" :settings="settings" ref="mailListPS">
                      <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
                          <li class="cursor-pointer email__mail-item" v-for="(mail, index) in mailList" :key="String(mail._id)" @click.stop="sendOpenMailRequest(mail)" :style="{transitionDelay: (index * 0.1) + 's'}">
                              <mail-item :mail="mail" :isSelected="isMailSelected(mail._id)" @addToSelected="addToSelectedMails" @removeSelected="removeSelectedMail" />
                          </li>
                      </transition-group>
                  </VuePerfectScrollbar>
              </div>
              <email-view
                  :base_url   = "$ApiKeys.BASE_URL"
                  :email       = "mailList"
                  :openMail      = "openMail"
                  :isSidebarActive = "isSidebarActive"
                  :mailFilter      = "mailFilter"
                  @markUnread      = "updateSingleMarkUnread"
                  @removeMail      = "removeOpenMail"
                  @previousMail    = "previousMail"
                  @nextMail        = "nextMail"
                  @moveTo          = "moveCurrentTo"
                  @closeSidebar    = "closeMailViewSidebar">
              </email-view>
              <vs-popup class="holamundo addIssuer" title="Status" :active.sync="showDeleteStatus.status">
                  <h5>{{ showDeleteStatus.msg }}</h5>
              </vs-popup>
          </div>
          <vs-row class="mt-6 pb-0 pt-2" vs-justify="center">
            <div style="width:max-content" v-if="!isSidebarActive">
              <vs-pagination :total="totalPages" v-model="pageIndex" @change="getMessages" v-show="!hasData"></vs-pagination>
            </div>
          </vs-row>
          <vs-popup class="holamundo"  title="Status" :active.sync="confirmDelete">
            <h5>Are you sure that you want to delete?</h5>
            <vs-row vs-justify="flex-end">
                <vs-button @click="moveTo('')" class="mr-4">Yes</vs-button>
                <vs-button @click="confirmDelete = false">No</vs-button>
            </vs-row>
        </vs-popup>
   </div>
</template>
<script>
import MailItem            from './MailItem.vue'
import EmailView           from './EmailView.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import EventBus from '@/event-bus.js';
import { genericErrorMessage, toast } from '@/keys/toast-messages';

export default {
  data() {
    return {
      timer: false,
      confirmDelete: false,

      mailList: [],
      hasData: false,
      pageIndex: 1,
      totalPages: 1,

      selected: [],
      itemsPerPage: 5,

      search: '',
      showDeleteStatus: {
        msg: '',
        status: false
      },

      openMail           : null,
      selectedMails        : [],
      isSidebarActive      : false,
      showThread           : false,
      clickNotClose        : true,
      isEmailSidebarActive : true,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
      genericErrorMessage, 
      toast
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) this.showThread = false
    },
    mailFilter() {
      this.selectedMails = []
      this.$refs.mailListPS.$el.scrollTop = 0
      this.toggleEmailSidebar()
    },
    windowWidth() {
      this.setSidebarWidth()
    }
  },
  computed: {
    mailFilter() {
      return this.$route.params.filter
    },
    emailTags() {
      return this.$store.state.email.mailTags
    },
    searchQuery: {
      get() {
        return this.$store.state.email.mailSearchQuery
      },
      set(val) {
        this.$store.dispatch('email/setEmailSearchQuery', val)
      }
    },
    selectAllCheckBox: {
      get() {
        return this.selectedMails.length
      },
      set(value) {
        value ? this.selectedMails = this.mails.map(mail => mail._id) : this.selectedMails = []
      }
    },
    mails() {
      if(this.mailList.length > 0){
        this.hasData = false;
      }
      else {
        this.hasData = true;
      }
      return this.mailList
    },
    selectAllIcon() {
      return this.selectedMails.length == this.mails.length ? 'icon-check' : 'icon-minus'
    },
    isMailSelected() {
      return (mailId) => this.selectedMails.indexOf(mailId) == -1 ? false : true
    },
    windowWidth() {
      return this.$store.state.windowWidth
    }
  },
  methods: {
    addToSelectedMails(mailId) {
      if (this.selectedMails.indexOf(mailId) === -1) this.selectedMails.push(mailId)
    },
    removeSelectedMail(mailId) {
      const mailIndex = this.selectedMails.indexOf(mailId)
      if (mailIndex !== -1) this.selectedMails.splice(mailIndex, 1)
    },
    moveTo(to) {
      this.deleteMails(this.selectedMails);
    },
    moveCurrentTo(to) {
      this.selectedMails = [this.openMailId]
      this.moveTo(to)
    },
    updateMarkUnread() {
      const payload = { emailIds: this.selectedMails, unreadFlag: true }
      this.$store.dispatch('email/setUnread', payload)
      this.selectedMails = []
    },
    removeOpenMail() {
      this.selectedMails = [this.openMailId]
      this.moveTo('trashed')
      this.isSidebarActive = false
    },
    toggleIsStarred() {
      const payload = { mailId: this.currentMail.id, value: !this.currentMail.isStarred }
      this.$store.dispatch('email/toggleIsMailStarred', payload)
    },
    nextMail() {
      const currentMailIndex = this.mails.findIndex((mail) => mail.id == this.openMailId)
      if (this.mails[currentMailIndex + 1]) this.openMailId = this.mails[currentMailIndex + 1].id
    },
    previousMail() {
      const currentMailIndex = this.mails.findIndex((mail) => mail.id == this.openMailId)
      if (this.mails[currentMailIndex - 1]) this.openMailId = this.mails[currentMailIndex - 1].id
    },
    updateSingleMarkUnread() {
      this.selectedMails = [this.openMailId]
      this.updateMarkUnread()
      this.isSidebarActive = false
    },
    updateLabels(label) {
      this.$store.dispatch('email/updateLabels', { mails: this.selectedMails, label: label })
      this.selectedMails = []
    },
    closeMailViewSidebar() {
      this.isSidebarActive = false
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isEmailSidebarActive = this.clickNotClose = false
      } else {
        this.isEmailSidebarActive = this.clickNotClose = true
      }
    },
    toggleEmailSidebar(value = false) {
      if (!value) {
        this.closeMailViewSidebar()
        if (this.clickNotClose) {
          return
        }
      }
      this.isEmailSidebarActive = value
    },
    async deleteMails(ids){
      this.confirmDelete = false;
       if(this.selectedMails.length == 0){
            this.showDeleteStatus = {
                msg: 'Please select atleast one message to delete',
                status: true
            };
        }
        else {
              this.$vs.loading({
                    background: 'rgba(1,2,3,.2)'
                });
              this.showDeleteStatus = {
                    msg: '',
                    status: false
                };

                return new Promise((resolve, reject) => {
                this.$axios.post(this.$ApiKeys.BASE_URL+this.$EndPoints.DeleteMessages,{
                    messageId: this.selectedMails
                }, 
                { 
                    headers: {
                        'Authorization': this.$localStorage.get('token')
                    }
                }).then(async res => {
                    this.$vs.loading.close();
                    if(res.data.success == true){
                        this.showDeleteStatus = {
                            msg: res.data.data.message,
                            status: true
                        };
                        await this.getMessages();
                        this.$root.$emit('updateApprovals',{});
                        this.selectedMails = [];
                    } else {
                        this.toast(this.genericErrorMessage());
                    }
                }).catch(e => {
                    this.$vs.loading.close();
                    if(e.response.data.errors.cardId){
                        this.showDeleteStatus = {
                            msg: e.response.data.errors.cardId,
                            status: true
                        };
                    }
                    else {
                        this.showDeleteStatus = {
                            msg: '',
                            status: false
                        };
                        if(e.response.status !== 401){
                            this.toast(this.genericErrorMessage());
                        }
                    }
                });
          });
        }
        
    },
    getMessages(name){
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.selectedMails = []
        this.$vs.loading.close();
        this.$vs.loading({
              background: 'rgba(1,2,3,.2)'
          });
          return new Promise((resolve, reject) => {
              this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.MessagesList, { 
                  params: {
                      searchquery: this.search,
                      page: name == 'search' ? 1 : this.pageIndex,
                      limit: this.itemsPerPage
                  },
                  headers: {
                      'Authorization': this.$localStorage.get('token')
                  }
              }).then(async res => {
                this.$vs.loading.close(); 
                if(res.data.success){
                    if(name == 'search'){
                        this.pageIndex = 1;
                    } 
                    this.totalPages = res.data.pageCount;
                    this.$root.$emit('updateApprovals',{});
                    this.$root.$on('refreshMessages',response => {
                        this.getMessages();
                        if(response.success){
                            this.showDeleteStatus = {
                                msg: response.msg,
                                status: true
                            };
                        }
                    });
                    resolve(
                        this.mailList = res.data.data,
                    );
                } else {
                    this.toast(this.genericErrorMessage());
                }
              }).catch(e => {
                  this.$vs.loading.close();  
                  if(e.response.status !== 401 && e.response.status !== 404){
                      this.toast(this.genericErrorMessage());
                  }
                  if(e.response.status == 404){
                    this.mailList = [];
                  }
              });
          });
      },500)
    },
    sendOpenMailRequest(mail){
        this.$vs.loading({
            background: 'rgba(1,2,3,.2)'
        });
        return new Promise((resolve, reject) => {
            this.$axios.get(this.$ApiKeys.BASE_URL+this.$EndPoints.MessageDetails, { 
                params: {
                    messageId: mail._id
                },
                headers: {
                    'Authorization': this.$localStorage.get('token')
                }
            }).then(async res => {
              this.$vs.loading.close();  
              if(res.data.success){
                  this.openMail = mail;
                  this.openMail.base_url = this.$ApiKeys.BASE_URL;
                  this.isSidebarActive = true
              } else {
                  this.toast(this.genericErrorMessage());
              }
                resolve(
                );
                
            }).catch(e => {
                 this.$vs.loading.close();  
                  if(e.response.status !== 401){
                      this.toast(this.genericErrorMessage());
                  }
                // console.log('error on getting messages: ',e);
            });
        });
    },
  },
  components: {
    MailItem,
    EmailView,
    VuePerfectScrollbar
  },
  created() {
    this.setSidebarWidth()
    this.getMessages();

      this.$vs.loading({
            background: 'rgba(1,2,3,.2)'
        });

    EventBus.$emit('resetToggleGroup',true);
  },
  mounted() {
    this.$root.$on('refreshMessageList',() => {
        this.getMessages();
    });
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>

<style>
 #email-app .vs-input--placeholder {
    vertical-align: middle;
    position:absolute;
    padding-top: 18px !important;
    padding-left: 40px !important;
    margin-top: 0px !important;
  }
  .sidebar-spacer {
    width: auto !important;
    margin: 0 !important;
  }
  #email-app{
    height: 68.5vh !important;
  }
  .email-content-scroll-area {
    /* height: auto !important; */
    padding-bottom: 12% !important;
    overflow: auto;
  }
  #email-app .vs-input--input {
    border-radius: 0 !important;
    margin-top: 0 !important;
  }
</style>